import { render } from "./SmPropertiesPlaceholder.vue?vue&type=template&id=3ca6c2f0&scoped=true"
import script from "./SmPropertiesPlaceholder.vue?vue&type=script&lang=js"
export * from "./SmPropertiesPlaceholder.vue?vue&type=script&lang=js"

import "./SmPropertiesPlaceholder.vue?vue&type=style&index=0&id=3ca6c2f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca6c2f0"]])

export default __exports__